(() => {
  if (!document.documentElement.classList.contains('mb-forms-gated')) return;

  const sessionKey = 'mebore_forms_seen_session_v1';
  const closedKey = 'mebore_forms_closed_at_v1';
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  const startedAt = Date.now();
  let released = false;
  let trigger = '';

  const getStored = (storage, key) => {
    try { return storage.getItem(key); } catch (_) { return null; }
  };
  const setStored = (storage, key, value) => {
    try { storage.setItem(key, value); } catch (_) { /* no-op */ }
  };
  const isSuppressed = () => {
    if (getStored(window.sessionStorage, sessionKey)) return true;
    const closedAt = Number(getStored(window.localStorage, closedKey) || 0);
    return closedAt > 0 && Date.now() - closedAt < sevenDays;
  };
  const formHosts = () => [...document.querySelectorAll('[id*="shopify-forms" i], [class*="shopify-forms" i], shopify-forms-embed, iframe[src*="forms-"]')];
  const gateHosts = () => {
    if (released) return;
    formHosts().forEach(host => {
      host.dataset.meboreFormsGated = 'true';
      host.style.setProperty('display', 'none', 'important');
    });
  };
  const release = nextTrigger => {
    if (released || isSuppressed()) return;
    released = true;
    trigger = nextTrigger;
    setStored(window.sessionStorage, sessionKey, trigger);
    document.documentElement.dataset.meboreModalTrigger = trigger;
    formHosts().forEach(host => {
      host.dataset.meboreModalTrigger = trigger;
      host.style.removeProperty('display');
    });
    window.MeboreModalGate = { trigger, dwell_ms: Date.now() - startedAt };
    window.dispatchEvent(new CustomEvent('mebore:modal-release', { detail: window.MeboreModalGate }));
  };

  if (isSuppressed()) {
    gateHosts();
    new MutationObserver(gateHosts).observe(document.documentElement, { childList: true, subtree: true });
    return;
  }

  const observer = new MutationObserver(gateHosts);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  gateHosts();

  const onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= 0.5) release('scroll50');
  };
  const onExit = event => {
    if (event.clientY <= 0 && !event.relatedTarget) release('exit_intent');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('mouseout', onExit);
  window.setTimeout(() => release('dwell20s'), 20000);

  document.addEventListener('click', event => {
    if (!released) return;
    const control = event.target.closest('button,[role="button"]');
    const label = `${control?.getAttribute('aria-label') || ''} ${control?.textContent || ''}`;
    if (/close|閉じる|キャンセル/i.test(label)) setStored(window.localStorage, closedKey, String(Date.now()));
  }, true);
})();
